if (!customElements.get('gift-trigger')) {
  class GiftTrigger extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('alexa:open-gift-drawer'));
      });
    }
  }
  customElements.define('gift-trigger', GiftTrigger);
}
